import { Grid, Card } from "@mui/material";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import { useTheme } from "@mui/material/styles";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  LabelList,
} from "recharts";

function GroupInsights({ groups }) {
  console.log(groups);
  const theme = useTheme();

  if (!groups.length) {
    return (
      <Card>
        <MDBox p={3}>
          <MDTypography variant="body2">No group data available</MDTypography>
        </MDBox>
      </Card>
    );
  }

  const colors = [
    theme.palette.primary.main,
    theme.palette.info.main,
    theme.palette.success.main,
    theme.palette.warning.main,
    theme.palette.error.main,
  ];

  return (
    <MDBox mt={3}>
      <Card>
        <MDBox p={2}>
          <MDTypography variant="h6" mb={2}>
            Group Insights
          </MDTypography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <MDTypography variant="caption">Lead Spread</MDTypography>

              <MDBox height={240}>
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Pie
                      data={groups}
                      dataKey="total"
                      nameKey="group"
                      outerRadius={80}
                      labelLine={false}
                      label={({ name, percent, x, y }) => (
                        <text
                          x={x}
                          y={y}
                          fontSize={10}
                          textAnchor="middle"
                          dominantBaseline="central"
                          fill="#666"
                        >
                          {`${(percent * 100).toFixed(0)}%`}
                        </text>
                      )}
                    >
                      {groups.map((entry, index) => (
                        <Cell key={index} fill={colors[index % colors.length]} />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </MDBox>
            </Grid>

            <Grid item xs={12} md={6}>
              <MDTypography variant="caption">Conversion Rate</MDTypography>

              <MDBox height={240}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={groups} layout="vertical" margin={{ left: 20, right: 20 }}>
                    <XAxis
                      type="number"
                      domain={[0, 1]}
                      tickFormatter={(v) => `${Math.round(v * 100)}%`}
                      tick={{ fontSize: 10 }}
                    />

                    <YAxis dataKey="group" type="category" width={120} tick={{ fontSize: 10 }} />

                    <Tooltip formatter={(v) => `${Math.round(v * 100)}%`} />

                    <Bar
                      dataKey="conversion_rate"
                      barSize={10}
                      minPointSize={5}
                      fill={theme.palette.success.main}
                    >
                      <LabelList
                        dataKey="conversion_rate"
                        position="right"
                        formatter={(v) => `${Math.round(v * 100)}%`}
                        style={{ fontSize: 10 }}
                      />
                    </Bar>
                  </BarChart>
                </ResponsiveContainer>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </MDBox>
  );
}

export default GroupInsights;
